export enum WeeklyUpdateReportCommentEnum {
  General = 'General',
  HSE = 'HSE',
  WTG = 'WTG',
  CBoP = 'CBoP',
  EBoP = 'EBoP',
}
export const weeklyUpdateReportCommentToLabel: {[technology: string]: string} = {
  [WeeklyUpdateReportCommentEnum.General]: 'General',
  [WeeklyUpdateReportCommentEnum.HSE]: 'HSE',
  [WeeklyUpdateReportCommentEnum.WTG]: 'WTG',
  [WeeklyUpdateReportCommentEnum.CBoP]: 'CBoP',
  [WeeklyUpdateReportCommentEnum.EBoP]: 'EBoP',
};
